import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconArchiveRestore",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, h, _, a) {
  return d(), l("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--archive-restore"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Archive Restore",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2 2.5a.5.5 0 0 0-.5.5v.5A.5.5 0 0 0 2 4h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2ZM.5 3A1.5 1.5 0 0 1 2 1.5h8A1.5 1.5 0 0 1 11.5 3v.5a1.5 1.5 0 0 1-1 1.415V9A1.5 1.5 0 0 1 9 10.5H8a.5.5 0 0 1 0-1h1a.5.5 0 0 0 .5-.5V5h-7v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 1 0 1H3A1.5 1.5 0 0 1 1.5 9V4.915A1.5 1.5 0 0 1 .5 3.5V3Zm5.146 3.146a.5.5 0 0 1 .708 0l1.5 1.5a.5.5 0 1 1-.708.708L6.5 7.707V10a.5.5 0 0 1-1 0V7.707l-.646.647a.5.5 0 1 1-.708-.708l1.5-1.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const A = /* @__PURE__ */ s(c, [["render", u]]);
export {
  A as default
};
//# sourceMappingURL=archive-restore.js.map
